// extracted by mini-css-extract-plugin
export default {"root":"_2sZaUeVu","info":"zod7gZ2A","link":"rWI-06yR","forecaLogo":"URT0JiV3","counter":"AcJf3Z1F"};